import React from 'react';
import Layout from './components/layout';

function App() {
  return (
    <Layout/>
  );
}

export default App;
